<template>
  <!-- 是否公开 组件 -->
  <el-select
    :placeholder="placeholder"
    clearable
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    placeholder: {
      default: '请选择公开/私有'
    },
    options: {
      default: () => [
        { label: '公开', value: 1 },
        { label: '私有', value: 0 }
      ]
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>

</style>
